/* eslint-disable */

import { closeContactFloating } from "../contact/contact_floating";
import { ILiferay } from "../interfaces/liferay";

declare const Liferay: ILiferay;

const MODULE_URL = '/static/paas-chat/';

const CHAT_TRIGGER_SELECTOR = '.chat-toggler';
const CONTAINER_ELEMENT_ID = 'chat-container';
const COUNTER_ELEMENT_CLASS = 'chat-counter';
const PAGE_TITLE_SELECTOR = 'h1.title';
const IFRAME_ID = 'chat-window';

const MESSAGE_STATECHANGE = 'chat/ui';
const MESSAGE_CHATDESTROY = 'chat/destroy';
const MESSAGE_TOGGLE = 'chat/toggle';

const CSS_NEWMESSAGES = 'has-new-messages';
const CSS_LOADED = 'loaded';
const CSS_ISOPEN = 'is-open';

interface ChatState {
    isOpen: boolean;
    unreadMessageCount: number;
    isConnected: boolean;
    serviceAvailable: boolean;
    justStarted: boolean;
}

export class Chat {
    private static containerElement: any;
    private static counterElement: any;
    private static iframeElement: JQuery<HTMLIFrameElement>;
    private static portalHost: string = window.location.protocol + '//' + window.location.host;

    public static init() {
        this.containerElement = jQuery('#' + CONTAINER_ELEMENT_ID);

        if (!this.containerElement.length) {
            return;
        }

        this.counterElement = jQuery('.' + COUNTER_ELEMENT_CLASS);

        jQuery(document).on('click', CHAT_TRIGGER_SELECTOR, (e: any) => {
            e.preventDefault();
            this.toggleChat();
        });

        window.addEventListener('message', this.handleMessage.bind(this), false);
    }

    private static toggleChat() {
        if (this.isChatLoaded()) {
            this.sendMessageToChat(MESSAGE_TOGGLE);
        } else {
            this.loadChat();
        }
    }

    private static handleMessage(message: any) {
        if (typeof message.data === 'string') {
            let data;

            try {
                data = JSON.parse(message.data);
            } catch {
                data = { type: null };
            }

            switch (data.type) {
                case MESSAGE_STATECHANGE:
                    this.onStateUpdated(data);
                    break;
                case MESSAGE_CHATDESTROY:
                    this.exitChat();
                    break;
                default:
                // connection established, joined room, etc., and non-chat messages
            }
        }
    }

    private static isChatLoaded(): boolean {
        return !!this.iframeElement;
    }

    private static sendMessageToChat(messageType: string) {
        const message = { type: messageType };

        (this.iframeElement.toArray() as any[]).forEach((element: HTMLIFrameElement) => {
            element.contentWindow.postMessage(JSON.stringify(message), this.portalHost);
        });
    }

    private static loadChat() {
        closeContactFloating()
        
        const host = encodeURIComponent(this.portalHost);
        const path = encodeURIComponent(window.location.pathname);

        const pageTitleElement = $(PAGE_TITLE_SELECTOR);
        let title: string;
        if (pageTitleElement.length) {
            title = pageTitleElement.text();
        } else {
            title = document.title;
        }

        const params = new URLSearchParams();
        params.set('host', host);
        params.set('path', path);
        params.set('title', title);
        params.set('category', 'Chat');
        params.set('theme', btoa(Liferay.ThemeDisplay.getPathThemeRoot()))

        const iFrameSrc = `${MODULE_URL}?${params.toString()}`;
        const iFrameElement = document.createElement('iframe');

        const iFrame = jQuery(iFrameElement);
        iFrame.attr('id', IFRAME_ID);
        iFrame.attr('src', iFrameSrc);

        this.containerElement.append(iFrame);
        this.iframeElement = iFrame;

        this.containerElement.addClass(CSS_LOADED);

        iFrame.on('load', () => this.sendMessageToChat(MESSAGE_TOGGLE));
    }

    private static onStateUpdated(state: ChatState) {
        if (!this.isChatLoaded()) {
            return;
        }

        this.containerElement.toggleClass(CSS_ISOPEN, state.isOpen);
        this.updateCounter(state.unreadMessageCount);
    }

    private static exitChat() {
        this.containerElement.empty();
        this.containerElement.removeClass(CSS_ISOPEN);
        this.containerElement.removeClass(CSS_LOADED);
        this.iframeElement = null;
        this.updateCounter(0);
    }

    private static updateCounter(unreadMessageCount: number) {
        this.counterElement.text(unreadMessageCount);
        this.counterElement.toggleClass(CSS_NEWMESSAGES, unreadMessageCount > 0);
    }
}